import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';

@Component({
  selector: 'app-static-finder',
  templateUrl: './static-finder.component.html',
  styleUrl: './static-finder.component.scss',
})
export class StaticFinderComponent implements OnInit {
  @Input() local!: boolean;
  @Input() lookup!: any;
  @Output() selectedElement: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('filterBox') filterBox!: ElementRef;

  constructor(private injector: Injector) {}

  items: any[] = [];
  datasource: any[] = [];
  pageOfItems?: Array<any>;
  sortProperty: string = 'id';
  sortOrder = 1;
  loading = false;

  ngOnInit(): void {
    this.loading = true;
    if (this.local) {
      let lookupName: string = '';
      switch (this.lookup.name) {
        case 'organisation':
          if (this.lookup.parameters && Array.isArray(this.lookup.parameters)) {
            if (
              this.lookup.parameters[0][0] === 'type' &&
              this.lookup.parameters[0][1] === 1
            ) {
              lookupName = 'mah';
            } else if (
              this.lookup.parameters[0][0] === 'type' &&
              this.lookup.parameters[0][1] === 2
            ) {
              lookupName = 'sponsor';
            }
          }
          break;
        case 'substanceparentcode':
          lookupName = 'substance';
          break;
        default:
          lookupName = this.lookup.name;
      }

      let data = this.injector
        .get(LookupGetService)
        .getLocalLookup(lookupName, this.lookup.parameters);
      this.datasource = data ? data : [];
      this.items = data ? data : [];
      this.loading = false;
      this.sortBy('name');
    } else {
      this.injector
        .get(LookupGetService)
        .getAll(this.lookup.name)
        .subscribe((data: any) => {
          this.datasource = data;
          this.items = data;
          this.loading = false;
          this.sortBy('name');
        });
    }

    // Use setTimeout for safety to ensure view is fully rendered
    setTimeout(() => this.filterBox.nativeElement.focus(), 0);
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';
    let cleanText = pastedText
      .split(/\r?\n/) // separa por líneas
      .map((s) => s.replace(/"/g, '')) // elimina comillas dobles
      .map((s) => s.trim()) // quita tabs y espacios delante/detrás
      .filter(Boolean) // elimina líneas vacías
      .join('|'); // únelas con |

    const target = event.target as HTMLTextAreaElement;
    const start = target.selectionStart;
    const end = target.selectionEnd;

    if (cleanText.lastIndexOf('|') === cleanText.length - 1) {
      cleanText = cleanText.substring(0, cleanText.length - 1);
    }

    this.filterBox.nativeElement.value =
      this.filterBox.nativeElement.value.substring(0, start) +
      cleanText +
      this.filterBox.nativeElement.value.substring(end);

    setTimeout(() => {
      target.selectionStart = target.selectionEnd = start + cleanText.length;
    });
  }

  filter(event: any) {
    if (event.key == 'Enter') {
      if (this.items.length == 1) {
        this.select(this.items[0].code, this.items[0].name);
      }
    } else {
      this.loading = true;

      let value = event.target.value;
      if (value.endsWith('|')) {
        value = value.slice(0, -1);
      }

      const searchTerms = value
        .toLowerCase()
        .split('|')
        .map((term: any) => term.trim());

      this.items = this.datasource.filter((item) => {
        const name = item.name?.toString().toLowerCase() ?? '';
        const code = item.code?.toString().toLowerCase() ?? '';

        return searchTerms.some(
          (term: any) => name.includes(term) || code.includes(term)
        );
      });

      if (this.items.length == 0) {
        this.pageOfItems = [];
      }

      this.loading = false;
    }
  }

  select(code: string, name: string) {
    this.selectedElement.emit({ selectedCode: code, selectedName: name });
  }

  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  sortBy(property: string) {
    this.sortOrder = property === this.sortProperty ? this.sortOrder * -1 : 1;
    this.sortProperty = property;
    this.items = [
      ...this.items.sort((a: any, b: any) => {
        let result = 0;
        if (a[property] < b[property]) {
          result = -1;
        }
        if (a[property] > b[property]) {
          result = 1;
        }
        return result * this.sortOrder;
      }),
    ];
  }

  sortIcon(property: string) {
    if (property === this.sortProperty) {
      return this.sortOrder === 1 ? '↑' : '↓';
    }
    return '';
  }

  getLookupNameByType() {
    let lookUpNameByType: string = '';

    if (this.lookup) {
      lookUpNameByType = this.lookup.name;

      switch (this.lookup.name.toLowerCase()) {
        case 'organisation':
          if (this.lookup.parameters && Array.isArray(this.lookup.parameters)) {
            if (
              this.lookup.parameters[0][0] === 'type' &&
              this.lookup.parameters[0][1] === 1
            )
              lookUpNameByType = 'mah';
            else if (
              this.lookup.parameters[0][0] === 'type' &&
              this.lookup.parameters[0][1] === 2
            )
              lookUpNameByType = 'sponsor';
          }
          break;
      }
    }

    return lookUpNameByType;
  }

  getPlaceHolderTemplate(): string {
    // Customized placeholder
    switch (this.getLookupNameByType().toLowerCase()) {
      case 'adminroute':
        return 'Search for routes of administration available in the XEVPRM';
      case 'atc':
        return 'Search for ATCs available in the XEVPRM';
      case 'mah':
        return 'Search for MAHs available in the XEVPRM';
      case 'mfl':
        return 'Search for master file locations available in the XEVPRM';
      case 'pharmform':
        return 'Search for pharmaceutical forms available in the XEVPRM';
      case 'ppiattachment':
      case 'psiattachment':
        return 'Search for attachments available in the XEVPRM [write 4 characters at least]';
      case 'source':
        return 'Search for sources available in the XEVPRM';
      case 'sponsor':
        return 'Search for Sponsors available in the XEVPRM';
      case 'substance':
      case 'substanceparentcode':
        return 'Search for substances available in the XEVPRM';
      default:
        return 'Search...';
    }
  }

  getPlaceHolderToolTipTemplate(): string {
    //Customized tooltip placeholder
    return (
      this.getPlaceHolderTemplate() +
      ' (Search executed while typing characters)'
    );
  }
}
